import { render, staticRenderFns } from "./IgnoraErroDlg.vue?vue&type=template&id=eda653e0"
import script from "./IgnoraErroDlg.vue?vue&type=script&lang=js"
export * from "./IgnoraErroDlg.vue?vue&type=script&lang=js"
import style0 from "./IgnoraErroDlg.vue?vue&type=style&index=0&id=eda653e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports